import React from "react";
import { Button } from "@anchor/react-components/dist/lib/components";
import { useNavigate } from  "react-router-dom"
import vessel from "../../Assets/Images/vessel-dark.png";
import "./CaseWithdrawn.scss";
const CaseWithdrawn = () => {
    const history = useNavigate();
  return (
    <div className="access-denied">
      <div className="text-section">
        <h1>
          Case has been Withdrawn
         {/* This case has been withdrawn and is no longer available for Approval. */}
         {/* The case you're trying to access has been withdrawn and is no longer available for approval. */}
        </h1>
        <p> 
          {/* Case has been Withdrawn. You can't access this page. */}

        The case you're trying to access has been withdrawn and is no longer available for approval.
        </p>
      </div>
      <div className="Image-section">
        <div className="loader-width">
          <img src={vessel} className="shipLoader" alt="Case Withdrawn" />
        </div>
      </div>
      <Button
        label="Back to Main page"
        fit="small"
        className="btn"
        data-testid="return-to-main-page"
        onClick={() => {
            history('/RequestPage')
        }}/>
    </div>
  );
};
export default CaseWithdrawn;
